// extracted by mini-css-extract-plugin
export default {"container":"k2mk5","poster":"YySVX","video--paused":"qh6j0"};